import { styled } from 'styled-components';

export const StyledGroupedFarmCart = styled.div`
  .cart-products-container.view {
    margin-bottom: 20px;
  }

  .order-title {
    font-size: 24px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: -25px;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .cart-products-farm-title {
    display: none;
  }

  .cart-products-farm-wrapper {
    margin-top: 20px;
    .cart-products-header {
      display: grid;
      grid-template-columns: minmax(115px, 3.6fr) 7.9fr 4.2fr 4.3fr minmax(51px, 2fr);
      align-items: center;
      justify-items: center;
      font-size: 14px;
      font-weight: 300;
      font-family: ${(props) => props.theme.fontText};
      text-transform: uppercase;
      color: ${(props) => props.theme.grey};
      padding: 10px 21.8px 8px 21.8px;

      .cart-cell-1,
      .cart-cell-2 {
        justify-self: start;
      }
    }

    .cart-products-content-wrapper {
      padding: 21px 21px 21px 21px;
      display: flex;
      gap: 15px;
      flex-direction: column;
      border: solid 1px ${(props) => props.theme.mediumGrey};
      border-radius: 5px;

      .title {
        display: none;
      }
    }

    .cart-delivery-container {
      height: fit-content;
      width: calc(100% + 42px);
      background-color: ${(props) => props.theme.summaryBackground};
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-top: solid 1px ${(props) => props.theme.mediumGrey};
      border-radius: 0px 0px 5px 5px;
      padding: 10px 20px 10px 20px;
      margin: 0 0 -21px -21px;

      .cart-delivery-info-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .cart-delivery-info {
          width: fit-content;
          height: fit-content;
          font-size: 16px;
          font-weight: 400;
          letter-spacing: -0.5px;
        }
      }

      .cart-delivery-button {
        .ant-btn {
          width: 350px;
          height: 52px;
          font-family: ${(props) => props.theme.fontText};
          font-weight: 600;
        }
      }

      .cart-delivery-button.choosen {
        height: 52px;
        border: solid 1px ${(props) => props.theme.brand02};
        background: transparent;
        color: ${(props) => props.theme.black};
        border-radius: 45px;
        .text {
          font-weight: 600;
          text-decoration: underline;
        }
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    width: 100%;
    .cart-products-farm-title {
      margin-top: 20px;
      display: flex;
      font-weight: 600;
      font-size: 16px;
      color: ${(props) => props.theme.brand01};
    }

    .cart-products-farm-wrapper {
      background-color: ${(props) => props.theme.cloudGray};
      border: 1px solid ${(props) => props.theme.silverGray};
      margin-top: 5px;
      border-radius: 5px;

      .cart-products-header {
        display: none;
      }

      .cart-products-content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 20px;
        border: 0;

        .title {
          display: none;
          margin: 6px 0;
          font-size: 16px;
          font-weight: 600;
        }
      }

      .cart-delivery-container {
        margin-top: -12px;
        background-color: transparent;

        .cart-delivery-button {
          .text {
            font-weight: 500;
          }
          width: 100%;
          .ant-btn {
            height: 34px;
            width: 100%;
          }
        }
        .cart-delivery-button.choosen {
          width: 35%;
          align-self: flex-start;
          border: none;
          .text {
            color: ${(props) => props.theme.darkRed};
            font-size: 15px;
            font-weight: 300;
            text-decoration: underline;
          }
          img {
            display: none;
          }
        }
      }
    }
  }
    
  @media only screen and (max-width: 768px) {
    .cart-products-farm-wrapper {
      .cart-products-content-wrapper {
        padding: 0;
        gap: 0;

        .cart-product.show-sum-card {
          margin-bottom: 10px;
        }
      }

      .cart-delivery-container {
        width: unset;
        border-top: none;
        padding: 0 10px 10px;
        margin: 0;

        &:has(.cart-delivery-button.choosen) {
          padding-top: 0;
        }

        .cart-delivery-button.choosen {
          .ant-btn {
            justify-content: end;
            padding: 0;
          }
        }
      }
    }
  }
`;
